/**
 * Sync Analytics "Need help?" → backend → Slack.
 * Intentionally separate from the global product Help modal.
 */

import { authFetch, apiErrorMessage } from './authFetch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export interface HelpStatus {
    enabled: boolean;
    images_enabled: boolean;
}

export interface SubmitAnalyticsHelpResult {
    ok: boolean;
    image_included: boolean;
    image_skipped: boolean;
}

export const helpApi = {
    async status(): Promise<HelpStatus> {
        const response = await authFetch(`${API_BASE_URL}/help/status`);
        if (!response.ok) {
            // Fail closed so the button still opens — submit will surface config errors.
            return { enabled: true, images_enabled: false };
        }
        return response.json();
    },

    async submitAnalyticsHelp(input: {
        message: string;
        practiceName?: string;
        locationId?: string;
        page?: string;
        image?: File | null;
    }): Promise<SubmitAnalyticsHelpResult> {
        const form = new FormData();
        form.append('message', input.message);
        if (input.practiceName) form.append('practice_name', input.practiceName);
        if (input.locationId) form.append('location_id', input.locationId);
        form.append('page', input.page || 'Sync Analytics');
        if (input.image) form.append('image', input.image, input.image.name);

        const response = await authFetch(`${API_BASE_URL}/help/analytics`, {
            method: 'POST',
            body: form,
            // Let the browser set multipart boundary — do not set Content-Type.
        });
        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new Error(apiErrorMessage(body, 'Failed to send help message'));
        }
        return response.json();
    },
};
